<template>
  <div ref="chartRef" style="width: 100%; height: 300px;"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "EtfSizeChart",
  props: {
    etfData: {
      type: Object,
      default: () => ({
        etfType: 0,
        worList: []
      })
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    etfData: {
      deep: true,
      handler() {
        this.renderChart();
      }
    }
  },
  mounted() {
    this.initChart();
    this.renderChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartRef);
      window.addEventListener("resize", this.handleResize);
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    },
    formatDate(dateNum) {
      const dateStr = dateNum.toString();
      if (dateStr.length !== 8) return dateStr;
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);
      return `${year}-${month}-${day}`;
    },
    renderChart() {
      if (!this.chart || !this.etfData.worList || this.etfData.worList.length === 0) {
        return;
      }

      const xAxisData = this.etfData.worList.map(item => this.formatDate(item.infoTime));

      const option = {
        title: {
          text: "份额",
          left: "center",
          textStyle: {
            fontSize: 14,
            fontWeight: "bold"
          }
        },
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            const item = params[0];
            return `<div style="font-weight:bold;margin-bottom:8px;">${item.axisValue}</div>
                    <div>${item.marker}份额: <span style="font-weight:bold;">${item.value}</span></div>`;
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "15%",
          top: "15%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xAxisData,
        },
        yAxis: {
          type: "value",
          name: "万份",
          nameTextStyle: {
            fontSize: 12,
            padding: [0, 0, 0, 10]
          },
          axisLabel: {
            fontSize: 12
          }
        },
        series: [
          {
            name: "ETF份额",
            type: "line",
            data: this.etfData.worList.map(item => item.etfSize),
            smooth: true,
            lineStyle: {
              width: 2,
              color: "#108ee9"
            },
            itemStyle: {
              color: "#108ee9"
            }
          }
        ]
      };

      this.chart.setOption(option);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>